export { DetailPopup } from './DetailPopup';
